import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgScatter = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 21,
	height: 20,
	viewBox: "0 0 21 20",
	fill: "none",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M19.25 18.75H3C2.66848 18.75 2.35054 18.6183 2.11612 18.3839C1.8817 18.1495 1.75 17.8315 1.75 17.5V1.25H3V17.5H19.25V18.75Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6.5 15.0002L6.6 15",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.5 11.0002L10.6 11",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6.5 11.0002L6.6 11",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.5 7.0002L10.6 7",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.5 8.0002L14.6 8",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15.5 4.0002L15.6 4",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeLinecap: "round"
		})
	]
});
export default SvgScatter;
